import { Button, NavigateDetailsButton, Space } from '@/components';
import { VITE_APP_BASENAME } from '@/config';
import { ExportOutlined } from '@ant-design/icons';
import type { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

type Props = ComponentProps<typeof NavigateDetailsButton>;

export const NavigateDetailsWithOpenButton: FC<Props> = ({
  pathPrefix,
  id,
  params,
}) => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <Space direction="vertical" align="center">
      <NavigateDetailsButton id={id} params={params} pathPrefix={pathPrefix} />
      <Button
        type="link"
        icon={<ExportOutlined />}
        onClick={() => {
          window.open(
            `${VITE_APP_BASENAME}${location.pathname}${pathPrefix ? `/${pathPrefix}` : ''}/${id}${params ? `?${params}` : ''}`,
            '_blank',
          );
        }}
      >
        {t('details')}
      </Button>
    </Space>
  );
};
